// plan-02 S05: pixel dust pass — 24-28 motes drifting, 4s reseed — bible S13B

import type { DrawPass } from '../canvas'

const MOTE_COUNT = 24
const RESEED_S = 4

interface Mote {
  x: number
  y: number
  vx: number
  vy: number
}

function seededMotes(seed: number, w: number, h: number): Mote[] {
  const out: Mote[] = []
  let s = seed
  function next(): number {
    s = (s * 1103515245 + 12345) & 0x7fffffff
    return s / 0x7fffffff
  }
  for (let i = 0; i < MOTE_COUNT; i++) {
    out.push({
      x: next() * w,
      y: next() * h,
      vx: (next() - 0.5) * 0.4,
      vy: (next() - 0.5) * 0.4,
    })
  }
  return out
}

export function createPixelDust(
  getConsensus: () => boolean,
  reduced: boolean,
): DrawPass {
  let motes: Mote[] = []
  let lastEpoch = -1
  let cachedW = 0
  let cachedH = 0

  return (ctx, w, h, t): void => {
    const epoch = Math.floor(t / RESEED_S)
    if (epoch !== lastEpoch || w !== cachedW || h !== cachedH) {
      motes = seededMotes(epoch, w, h)
      lastEpoch = epoch
      cachedW = w
      cachedH = h
    }

    const count = getConsensus() ? 28 : MOTE_COUNT
    ctx.fillStyle = 'rgba(0, 90, 0, 0.18)'
    for (let i = 0; i < Math.min(count, motes.length); i++) {
      const m = motes[i]
      if (!reduced) {
        m.x += m.vx
        m.y += m.vy
        if (m.x < 0) m.x = w
        if (m.x > w) m.x = 0
        if (m.y < 0) m.y = h
        if (m.y > h) m.y = 0
      }
      const size = 1 + (i % 2)
      ctx.fillRect(m.x, m.y, size, size)
    }
  }
}
